/** @type {Map<string, import('./documentPreviewTypes.js').GeneratedArtifactPreview>} */
export const payloadsById = new Map()

/**
 * @param {import('./documentPreviewTypes.js').GeneratedArtifactPreview} artifact
 */

export function registerArtifactPayload(artifact) {
  payloadsById.set(artifact.artifactId, artifact)
}

/**
 * @param {string} artifactId
 * @returns {import('./documentPreviewTypes.js').GeneratedArtifactPreview | null}
 */

export function getArtifactPayload(artifactId) {
  return payloadsById.get(artifactId) ?? null
}
